import styled from 'styled-components';
import { flexKeys, flexMixin } from '../mixins/flex';
import { boxSizingKeys, boxSizingMixin, fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin, marginKeys, marginMixin, paddingKeys, paddingMixin } from '../mixins/layout';
import { withOmitProps, byMedia, getPx } from '../helpers';
/**
 * more about it https://alistapart.com/article/axiomatic-css-and-lobotomized-owls/
 */
const createGap = (direction, value) => ({
  '& > * + *': {
    ['margin-' + direction]: getPx(value)
  }
});
const mediaGap = byMedia(v => `gap: ${getPx(v)};`);
const rowGapMixin = ({
  rowGap
}) => rowGap && createGap('left', rowGap);
const columnGapMixin = ({
  columnGap
}) => columnGap && createGap('top', columnGap);
const gapMixin = ({
  gap
}) => gap && mediaGap(gap);
const Flex = styled.div.withConfig(withOmitProps([...boxSizingKeys, ...fullWidthKeys, ...fullHeightKeys, ...flexKeys, ...marginKeys, ...paddingKeys, 'rowGap', 'columnGap', 'gap']))`
  ${boxSizingMixin}
  ${fullWidthMixin}
  ${fullHeightMixin}
  ${flexMixin}
  ${marginMixin}
  ${paddingMixin}
  ${rowGapMixin}
  ${columnGapMixin}
  ${gapMixin}
`;
export default Flex;